import { contentAi } from '@mi-front/api-clients';
import { Alert, AlertTitle, Box, CircularProgress } from '@mui/material';
import { useIntl } from 'react-intl';

export function PntApiResultStatus({ content }: { content: contentAi.ContentDto }) {
  const { $t } = useIntl();

  if (content.pntApiResult.status !== 'COMPLETED') {
    return (
      <Box>
        <Alert severity="info" icon={<CircularProgress size={20} />}>
          <AlertTitle>
            {$t({
              id: 'contentAi.preparingMedia',
              defaultMessage: 'Preparando media para analizar',
            })}
          </AlertTitle>
        </Alert>
      </Box>
    );
  }

  return null;
}
